import { AXNUIMobileCompletePage } from "@iddataweb/idw-common-ui/containers";
import { useSelector } from "react-redux";
import { getLanguageContent } from "@redux/selectors/language-selectors";

export const MobileCompletePage = () => {
    const content = useSelector(getLanguageContent);

    return (
        <AXNUIMobileCompletePage
            axnuiContent={content}
            hasError={false} //todo - need to know when an error occurs
        />
    );
};